import envs from '@envs'

import cookie from '@/utils/browser/cookie'
import tracr from '@/utils/tracr'

export const getAnalyticsPayload = () => {
  return {
    source_url: getSourceUrl(),
    referrer_url: sessionStorage.getItem('referrerUrl') || '',
    anonymous_id: localStorage.getItem('tracr_anonymous_id') || '',
    session_id: sessionStorage.getItem('tracr_session_id') || '',
    user_agent: sessionStorage.getItem('userAgent') || '',
    ga4_client_id: envs?.GA4_ID || '',
    pixel_fbc: cookie.getItem('_fbc') || '',
    pixel_fbp: cookie.getItem('_fbp') || '',
    google_cookie: cookie.getItem('_ga') || '',
    google_client_id: sessionStorage.getItem('gaClientId') || ''
  }
}

const setGa4ClientId = () => {
  const ga4ClientId = sessionStorage.getItem('gaClientId')
  if (!ga4ClientId) {
    window?.gtag?.('get', envs?.GA4_ID, 'client_id', (client_id) => {
      sessionStorage.setItem('gaClientId', client_id)
    })
  }
}

const getSourceUrl = () => {
  const url = localStorage.getItem('sourceUrl')
  const href = window.location.href

  if (!url || url.includes('fbclid=')) {
    localStorage.setItem('sourceUrl', href)
  }

  if (href && href.toLowerCase().includes('ref=') && href !== url) {
    localStorage.setItem('sourceUrl', href)
    return href
  }

  return url || href
}

const setSourceUrl = ({ shortUrls }) => {
  const sourceUrl = localStorage.getItem('sourceUrl')
  const href = window.location.href
  const isShortUrlInHref = shortUrls?.some((shortUrl) =>
    href.includes(shortUrl)
  )

  if (!sourceUrl && !isShortUrlInHref) {
    localStorage.setItem('sourceUrl', href)
  }
}

export const getRedTesting = () => {
  const redTesting = localStorage.getItem('rvexp.data')

  if (!redTesting) return

  const { experiments } = JSON.parse(redTesting)

  return experiments
}

const setDocumentReferrer = () => {
  const referrerUrl = sessionStorage.getItem('referrerUrl')
  if (!referrerUrl) {
    sessionStorage.setItem('referrerUrl', document.referrer)
  }
}

const setUserAgent = () => {
  const userAgent = sessionStorage.getItem('userAgent')
  if (!userAgent) {
    sessionStorage.setItem('userAgent', navigator.userAgent)
  }
}

const setup = ({ tracrConfig, shortUrls } = {}) => {
  setGa4ClientId()
  setSourceUrl({ shortUrls })
  setDocumentReferrer()
  setUserAgent()
  tracr.setup({
    clientId: tracrConfig?.clientId,
    appKey: tracrConfig?.appKey,
    environment: tracrConfig?.environment
  })
}

export default {
  getRedTesting,
  getAnalyticsPayload,
  setGa4ClientId,
  setSourceUrl,
  setDocumentReferrer,
  setUserAgent,
  setup
}
